import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/auth-context';
import { usePermissions } from '../../core/hooks/usePermissions';
import type { UIModule } from '../../core/types/permissions.types';

export const LoadingFallback: React.FC = () => (
  <div
    className="flex justify-content-center align-items-center"
    style={{ height: '100vh' }}
  >
    <div className="loading-spinner" />
  </div>
);

export const PermissionRoute: React.FC<{
  module: UIModule;
  children: React.ReactNode;
}> = ({ module, children }) => {
  const { isLoading } = useAuth();
  const { canView } = usePermissions();
  if (isLoading) return <LoadingFallback />;
  return canView(module) ? <>{children}</> : <Navigate to="/devices" replace />;
};

export const AdminRoute: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { isAdmin, isLoading } = useAuth();
  if (isLoading) return <LoadingFallback />;
  return isAdmin ? <>{children}</> : <Navigate to="/devices" replace />;
};

export const ProtectedRoute: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { user, isLoading } = useAuth();
  if (isLoading) return <LoadingFallback />;
  return user ? <>{children}</> : <Navigate to="/login" replace />;
};

